import './ForgeApp.css';
import { AppShell } from '../AppShell';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { BrowserRouter as Router } from 'react-router-dom';
import { SnackbarProvider } from '../../hooks/snackbar';
import { ThemeProvider } from '../../theme/muiTheme';
import MomentUtils from '@date-io/moment';
import React from 'react';
export const ForgeApp = (props) => {
    return (React.createElement(ExternalProviderWrappers, { baseName: props.baseName },
        React.createElement(AppShell, Object.assign({}, props), props.children)));
};
export const ExternalProviderWrappers = ({ children, baseName }) => {
    return (React.createElement(Router, { basename: baseName },
        React.createElement(ThemeProvider, null,
            React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
                React.createElement(SnackbarProvider, null, children)))));
};
export default ForgeApp;
//# sourceMappingURL=ForgeApp.js.map